import {XauditModel} from '../../xaudit.model';
import {TdoUserGroupConfigurationModel} from './tdo-user-group-configuration.model';

export class TdoUserInGroupConfigurationModel extends XauditModel {
  UserID: string;
  UserGroupId: string;

  // Navigation properties
  cfgTDOUserGroup: TdoUserGroupConfigurationModel;
}
